import { selectAssignment } from '@redux/experiments/selectors/index';
import type { DirectoryPageFiltersAssignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { PEACE_OF_MIND_EXCLUDED_CATEGORY_CODES } from '../data/peaceOfMindExcludedCategoryCodes';

export const directoryPageFiltersSelector = (
	state: State,
): DirectoryPageFiltersAssignment => {
	const categoryCode = state.category.code;

	if (
		!categoryCode ||
		PEACE_OF_MIND_EXCLUDED_CATEGORY_CODES.has(categoryCode)
	) {
		return null;
	}

	return (selectAssignment(state, ['pomDirectoryPageFilters']) ??
		null) as DirectoryPageFiltersAssignment;
};
